import { Circle, XStack } from "tamagui";

import { Text } from "@/components";

interface AffiliationBannerProps {
  active: boolean | null;
  partnerName: string | null;
}

export default function AffiliationBanner({
  active,
  partnerName,
}: AffiliationBannerProps) {
  if (!partnerName) return null;

  const isActive = active === true;

  return (
    <XStack
      padding="$200"
      marginBottom="$200"
      borderRadius="$150"
      outlineWidth={2}
      outlineColor={isActive ? "$strokeNeutral" : "$red"}
      outlineStyle="solid"
      alignItems="center"
      gap="$100"
    >
      <Circle
        size="$100"
        backgroundColor={isActive ? "$green" : "$red"}
        flexShrink={0}
      />
      <Text size="$sm">
        {isActive
          ? `Membership active: Provided by ${partnerName}`
          : "Membership inactive"}
      </Text>
    </XStack>
  );
}
